<template>
  <div class="welcome-puyang">
    <div class="welcome-container">
      <div class="title-bar">
        <h2 class="font-white site-title">
          濮阳市工程担保电子保函系统
        </h2>
        <div class="addons">
          <a href="./" class="addon-link">使用说明</a>
          <a href="./" class="addon-link">联系我们</a>
        </div>
      </div>
      <div class="login-area">
        <!-- <div class="quick-search">
          <Input search enter-button placeholder="输入保函编号、项目名称或被保证人进行搜索..." size="large" @on-search="handleQuickSearch" />
        </div> -->
        <div class="entries">
          <div class="entry red" @click="$router.push({name:'Login', query:{mode:'puyang', role:'supervisor'}})">
            <div class="title">监管人登录</div>
            <div class="icon"><Icon type="ios-desktop" /></div>
          </div>
          <div class="entry green" @click="$router.push({name:'Login', query:{mode:'puyang', role:'guarantor'}})">
            <div class="icon"><Icon type="ios-person" /></div>
            <div class="title">经办机构登录</div>
          </div>
          <div class="entry blue" @click="$router.push('/verify')">
            <div class="title">保函验真</div>
            <div class="icon"><Icon type="ios-search" /></div>
          </div>
          <div class="entry yellow" @click="$router.push('/internal-bulletin')">
            <div class="icon"><Icon type="ios-megaphone" /></div>
            <div class="title">内部通报</div>
          </div>
        </div>
      </div>
      <!-- <div class="stats-bar">
        <div class="stat-item">
          <div class="stat-value">{{stats.total}}</div>
          <div class="stat-label">保函总数</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{stats.active}}</div>
          <div class="stat-label">在保中</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{stats.expiring}}</div>
          <div class="stat-label">30日内到期</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{stats.guarantors}}</div>
          <div class="stat-label">经办机构</div>
        </div>
      </div> -->
      <Footer class="footer" :style="{padding: '5px 0px', color: '#ccc', fontSize: '12px'}" />
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default {
  name: 'Welcome_PuYang',
  components: {
    Footer
  },
  data () {
    return {
      loading: false,
      stats: {
        total: 0,
        active: 0,
        expiring: 0,
        guarantors: 0
      }
    }
  },
  created () {
  },
  mounted () {
    window.localStorage.setItem('view-mode', 'puyang')
    // let backImgUrl = this.$store.getters.sysConfigs['WELCOME_BACKGROUND_IMAGE_URL'] || 'bg_01.jpg'
    // if (backImgUrl && backImgUrl.toLowerCase().indexOf('http') === 0) {
    //   backImgUrl = `url(${backImgUrl})`
    // } else {
    //   backImgUrl = `url('/static/'${backImgUrl})`
    // }
    // document.querySelector('.welcome-puyang').style.backgroundImage = backImgUrl
    this.loadStats()
  },
  methods: {
    handleQuickSearch (value) {
      if (value) {
        this.$router.push({ path: '/guarantees/list', query: { keyword: value } })
      }
    },
    async loadStats () {
      // 从统计接口获取数据，暂时使用静态值
      this.stats = {
        total: 0,
        active: 0,
        expiring: 0,
        guarantors: 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.welcome-puyang {
  height: 100vh;
  background-color: #f2f2f2;
  overflow: hidden;
  color: #efefef;
  background-image: url('./../assets/puyang_bg.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;
  .welcome-container {
    .title-bar {
      width: 100%;
      position: absolute;
      top: 0;
      background: @primaryColor;
      padding: 12px 32px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .site-title {
      }
      .addons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        .addon-link {
          color: #e2e2e2;
          padding: 0 10px;
          &:hover {
            color: #fff;
          }
        }
      }
    }

    position: relative;
    z-index: 100;
    padding: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .login-area {
    position: relative;
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .quick-search {
    width: 500px;
    margin-bottom: 30px;
  }
  .entries {
    width: 420px;
    position: relative;
    display: flex;
    flex-direction: column;
    .entry {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      width: 100%;
      margin-bottom: 6px;
      opacity: 0.82;
      transition: all .3s linear;
      cursor: pointer;
      .title {
        height: 100px;
        background: @primaryColor;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        font-size: 22px;
        font-weight: bold;
      }
      .icon {
        padding: 0 40px;
        border: 2px solid rgba(0,0,0,0.25);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
        background: rgba(0,0,0,0.15);
        transition: all .3s linear;
        color: rgba(0,0,0,0.6);
      }
      &:last-child {
        margin-left: 6px;
      }
      &:hover {
        opacity: 1;
        .icon {
          background: rgba(255,255,255,0);
        }
      }
      &.red {
        .title {
          background: linear-gradient(to bottom, rgb(255, 31, 31), rgb(131, 12, 12));
        }
      }
      &.green {
        .title {
          background: linear-gradient(to bottom, rgb(23, 245, 97), rgb(3, 122, 63));
        }
      }
      &.blue {
        .title {
          background: linear-gradient(to bottom, rgb(23, 182, 245), rgb(2, 62, 141));
        }
      }
      &.yellow {
        .title {
          background: linear-gradient(to bottom, rgb(241, 245, 23), rgb(180, 98, 4));
        }
      }
    }
  }

  .stats-bar {
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    background: rgba(255,255,255,0.9);
    padding: 15px 30px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    .stat-item {
      text-align: center;
      padding: 0 20px;
      border-right: 1px solid #ddd;
      &:last-child {
        border-right: none;
      }
      .stat-value {
        font-size: 28px;
        font-weight: bold;
        color: @primaryColor;
      }
      .stat-label {
        font-size: 12px;
        color: #666;
        margin-top: 4px;
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 5px;
    left: 5px;
  }
}
</style>